import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const FitToDoc = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H9a.5.5 0 0 0 0 1h5.293l-2.147 2.146a.5.5 0 0 0 .708.708l3-3ZM.146 7.646a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708-.708L1.707 8.5H7a.5.5 0 0 0 0-1H1.707l2.147-2.146a.5.5 0 1 0-.708-.708l-3 3Z"
        fill={color}
      />
    </svg>
  )
})

export default FitToDoc
